module.exports = __webpack_public_path__ + "static/media/thumb-togetherwevote.29bb8038.png";